import type ContentfulClient from '@b2ag/contentful'
import { NATIONAL_SCOPE } from '../../domain/utils/constantes'
import type { IBannerRepository } from '../../domain/repository/IBannerRepository'
import type { Banner } from '../../domain/blocs/Banner'
import { mapBannerFromApi } from '../mapper/homeBanner.mapper'
import { i18n } from '@b2ag/locale'
import { filterBlocBySegment } from '../../domain/utils/filterContentListBySegment'

const MAX_BANNERS = 2

export class BannerRepository implements IBannerRepository {
  constructor(public readonly client: ContentfulClient) {}

  async getBannersByFilter(
    filter: {
      tags?: string[]
      keywords?: string[]
    } = {
      tags: [],
      keywords: [],
    },
    partnerScope: string = NATIONAL_SCOPE,
  ): Promise<Array<Banner>> {
    const query = {
      include: 1,
      content_type: 'banner',
      'fields.partnerFilter[in]': partnerScope,
      'fields.visibilityProductSheet[ne]': true,
      'metadata.tags.sys.id[in]': filter.keywords,
      limit: MAX_BANNERS,
    }

    return this.client.api.withoutUnresolvableLinks.getEntries<any>(query).then((content) => {
      return content.items
        .filter((banner) => filterBlocBySegment(banner, filter.tags || []))
        .map(mapBannerFromApi)
        .filter(Boolean) as Banner[]
    })
  }

  async getBannersForProductSheet(partnerScope: string = NATIONAL_SCOPE, tags: string[] = []): Promise<Array<Banner>> {
    const query = {
      include: 1,
      content_type: 'banner',
      'fields.visibilityProductSheet': true,
      'fields.partnerFilter[in]': partnerScope,
      order: ['-sys.updatedAt'],
      locale: i18n.locale,
    }
    if (tags.length) query['metadata.tags.sys.id[in]'] = tags
    return this.client.api.withoutUnresolvableLinks
      .getEntries(query)
      .then((content) => content.items.map(mapBannerFromApi).filter(Boolean) as Banner[])
  }
}
